import React, { useEffect, useState } from 'react';
import { CELEBRATE_EVENT } from '../celebration';

const COLORS = ['#16a34a', '#eab308', '#4f46e5', '#ec4899', '#06b6d4'];
const PIECE_COUNT = 26;

// Ein Konfetti-Burst pro Trigger, damit CSS-Animationen bei einem zweiten
// schnellen Abschluss zuverlässig neu starten (key wechselt).
function buildPieces() {
  return Array.from({ length: PIECE_COUNT }, (_, i) => ({
    id: i,
    left: Math.random() * 100,
    delay: Math.random() * 0.15,
    duration: 1.1 + Math.random() * 0.6,
    color: COLORS[i % COLORS.length],
    rotate: Math.round(Math.random() * 360),
    drift: (Math.random() - 0.5) * 60,
  }));
}

export default function Celebration() {
  const [burst, setBurst] = useState(null); // { key, pieces }

  useEffect(() => {
    const onCelebrate = () => {
      setBurst({ key: Date.now(), pieces: buildPieces() });
    };
    window.addEventListener(CELEBRATE_EVENT, onCelebrate);
    return () => window.removeEventListener(CELEBRATE_EVENT, onCelebrate);
  }, []);

  useEffect(() => {
    if (!burst) return;
    const t = setTimeout(() => setBurst(null), 1800);
    return () => clearTimeout(t);
  }, [burst]);

  if (!burst) return null;

  return (
    <div className="celebration-overlay" aria-hidden="true">
      {burst.pieces.map(p => (
        <span
          key={burst.key + '-' + p.id}
          className="celebration-piece"
          style={{
            left: `${p.left}%`,
            background: p.color,
            animationDelay: `${p.delay}s`,
            animationDuration: `${p.duration}s`,
            '--drift': `${p.drift}px`,
            '--rotate': `${p.rotate}deg`,
          }}
        />
      ))}
    </div>
  );
}
